import React from "react";
import { ArrowRight } from "lucide-react";
import { useNavigate } from "react-router-dom";
const FinalCtaComp = () => {
  const navigate = useNavigate();

  return (
    <div className="w-full max-w-lg mx-auto mb-20">
      <div className="p-8 bg-gradient-to-br from-slate-950/80 to-fuchsia-950/60 backdrop-blur-sm rounded-xl border border-red-900/20 text-center">
        <h2 className="text-3xl font-bold mb-4 text-pink-400 max-sm:text-2xl">
          Unleash Your Desires
        </h2>
        <p className="text-white mb-8">
          Join thousands already indulging in the ultimate AI intimate
          experience
        </p>

        <button
          className="px-10 py-4 bg-gradient-to-r from-red-800 via-red-900 to-red-950 rounded-full text-xl font-medium shadow-lg shadow-red-900/20 btn-hover-effect max-sm:px-4 max-sm:py-2 max-sm:text-base"
          onClick={() => navigate("/sign-up")}
        >
          <span className="flex items-center justify-center">
            <span className="max-sm:text-sm">Satisfy Your Curiosity</span>
            <ArrowRight size={18} className="ml-2" />
          </span>
        </button>

        <p className="mt-4 text-sm text-pink-400/70">No credit card required</p>
      </div>
    </div>
  );
};

export default FinalCtaComp;
